import { esc } from '@presentation/shell/format';

export interface RowAction {
  action: string;
  label: string;
  variant?: 'ghost' | 'danger' | 'secondary';
  adminOnly?: boolean;
}

/**
 * Colonne d'actions d'une ligne de tableau (boutons `data-action` / `data-id`).
 * @param rowContext — contexte W-13 pour `aria-label` (« Modifier — Jean Ondo »).
 */
export function renderRowActions(
  id: string,
  actions: readonly RowAction[],
  rowContext?: string,
): string {
  const ctx = rowContext?.trim();
  const buttons = actions
    .map((a) => {
      const variant = a.variant ?? 'ghost';
      const admin = a.adminOnly ? ' rh-admin-only' : '';
      const aria = ctx
        ? ` aria-label="${esc(a.label)} — ${esc(ctx)}"`
        : ` aria-label="${esc(a.label)}"`;
      return `<button type="button" class="btn btn-${variant} btn-sm${admin}" data-action="${esc(a.action)}" data-id="${esc(id)}"${aria}>${esc(a.label)}</button>`;
    })
    .join('');
  return `<div class="row-actions">${buttons}</div>`;
}
